
// You can write more code here

/* START OF COMPILED CODE */

import Tile from "../../game/Tile";

/* START-USER-IMPORTS */
import {GameConfig} from "../../game/config/gameConfig";
import Vector2 = Phaser.Math.Vector2;
import Phaser from "phaser";
import {LevelManager} from "~/js/game/LevelManager";
/* END-USER-IMPORTS */

export default class Critter extends Tile {

  constructor(scene: Phaser.Scene,levelManager:LevelManager, x: number, y: number, properties?:any[], texture?: string, frame?: number | string) {

    super(scene,levelManager, x ?? 0, y ?? 0,properties, texture || "__DEFAULT", frame);
    /* START-USER-CTR-CODE */
    this.vx = 5 * Phaser.Math.Between(0,10) > 5? 1: -1;
    this.vy = 5 * Phaser.Math.Between(0,10) > 5? 1: -1;
    this.prevX = x ?? 0;
    this.prevY = y ?? 0;
    this.levelManager = levelManager;
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  private vx:number;
  private vy:number;
  private prevX:number = 0;
  private prevY:number = 0;
  private hitList:Tile[] = [];
  private hitTime:number = 0;
  private beenHit:boolean = false;

  updateLoop(time:number, delta:number) {
    if(this.beenHit)
    {
      return;
    }
    if (this.levelManager != undefined) {
      if (this.x < this.levelManager.mapLeftBorder && this.vx < 0) {
        this.x = this.levelManager.mapLeftBorder;
        this.vx *= -1;
      }
      if (this.x > this.levelManager.mapRightBorder && this.vx > 0) {
        this.x = this.levelManager.mapRightBorder;
        this.vx *= -1;
      }

      if (this.y < this.levelManager.mapTopBorder && this.vy < 0) {
        this.y = this.levelManager.mapTopBorder;
        this.vy *= -1;
      }

      if (this.y > this.levelManager.mapBottomBorder && this.vy > 0) {
        this.y = this.levelManager.mapBottomBorder;
        this.vy *= -1;
      }

      let collisionData = this.levelManager.hitObject(this.x, this.y, this.width/2, this.prevX, this.prevY, false);
      

      if(collisionData != null) {
        if(this.hitList.indexOf(collisionData?.tile) == -1)
        {
          let v: Vector2 = new Phaser.Math.Vector2(this.vx, this.vy);
          let normal = collisionData.normal;
          let point = collisionData.point;
          let tmp: Vector2 = this.multiply(-2 * this.dot(normal, v), normal);
          this.x = point.x;
          this.y = point.y;
          this.vx += tmp.x;
          this.vy += tmp.y;
          this.hitList.push(collisionData.tile);
        }
      }

      collisionData = this.levelManager.hitBumper(this.x, this.y, this.width/2, this.prevX, this.prevY);
      
      if(collisionData != null) {
        if(this.hitList.indexOf(collisionData.tile) == -1)
        {
          let v: Vector2 = new Phaser.Math.Vector2(this.vx, this.vy);
          let normal = collisionData.normal;
          let point = collisionData.point;
          let tmp: Vector2 = this.multiply(-2 * this.dot(normal, v), normal);
          this.x = point.x;
          this.y = point.y;
          this.vx += tmp.x;
          this.vy += tmp.y;
          this.hitList.push(collisionData.tile);
        }
      }
    }

    this.prevX = this.x;
    this.prevY = this.y;
    this.x += this.vx;
    this.y += this.vy;

    if(this.vx < 0)
    {
      this.scaleX = -1;
    }
    else{
      this.scaleX = 1;
    }

    this.setDepth(this.y);

    this.hitTime += delta;
    if(this.hitTime > 100)
    {
      if(this.hitList.length > 0)
      {
      this.hitList.splice(0,1);
      }
      this.hitTime = 0;
    }
  }

  public override hitTile(): boolean {
    this.beenHit = true;
    this.setDepth(1000);

    this.scene.add.tween({
      targets:this,
      angle: 720,
      duration:2000,
      ease:Phaser.Math.Easing.Quadratic.InOut
    });

    this.scene.add.tween({
      targets:this,
      x: 960,
      scaleX:this.scaleX * 10,
      scaleY:this.scaleY * 10,
      duration:800,
      ease:Phaser.Math.Easing.Quadratic.InOut
    });

    this.scene.add.tween({
      targets:this,
      y: "-= 100",
      duration:300,
      ease:Phaser.Math.Easing.Quadratic.Out
    });

    this.scene.add.tween({
      targets:this,
      y: 1200,
      duration:400,
      delay:300,
      ease:Phaser.Math.Easing.Quadratic.In
    }).on("complete",()=>{
      this.destroy(true);
    });

    return true;
  }

private multiply(multi:number, n:Vector2)
{
  return new Phaser.Math.Vector2(n.x*multi,n.y*multi);
}
private dot(a:Vector2, b:Vector2)
{
  return a.x*b.x + a.y*b.y;
}

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
